import { render, staticRenderFns } from "./CmgPaymentCardLogo.vue?vue&type=template&id=5980e4ae&scoped=true&lang=pug"
import script from "./cmg-payment-card-logo.ts?vue&type=script&lang=ts&external"
export * from "./cmg-payment-card-logo.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPaymentCardLogo.vue?vue&type=style&index=0&id=5980e4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980e4ae",
  null
  
)

export default component.exports